import { Link } from "react-router-dom";

import { Box, Button, Stack, Typography } from "@mui/material";
import NotFoundSvg from "../assets/404.svg";

export const NotFound = () => (
  <Stack
    sx={{
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    }}
  >
    <Box component="img" src={NotFoundSvg} sx={{
      height: "40%"
    }} />
    <Typography variant="h4" sx={{ mt: 10 }}>
      Halaman tidak ditemukan
    </Typography>
    <Typography color="text.secondary" sx={{ mt: 1 }}>
      Alamat yang Anda buka tidak ada atau sudah dipindahkan.
    </Typography>
    <Button component={Link} to="/dashboard" sx={{ mt: 2 }}>
      Kembali ke Dashboard
    </Button>
  </Stack>
);
